import { HOME_SOURCE_TAB } from './ui-active-session';

export function shouldApplyLibrarySearchToSourceRows({
  hasLibrarySearch,
  currentSourceTab,
}: {
  hasLibrarySearch: boolean;
  currentSourceTab: string | null | undefined;
}): boolean {
  return hasLibrarySearch && currentSourceTab === HOME_SOURCE_TAB;
}
